import DatePicker from 'react-datepicker';

export interface DateFilterParameters {
    startDate: Date;
    set_startDate: React.Dispatch<React.SetStateAction<Date>>;
    endDate: Date;
    set_endDate: React.Dispatch<React.SetStateAction<Date>>;
}

export const DateFilter: React.FC<DateFilterParameters> = ({ startDate, set_startDate, endDate, set_endDate }) => {
    return (
        <div className='date-filter'>
            <div>Dates between</div>
            <DatePicker
                id='startDate'
                className='date-filter-date-picker'
                selected={startDate}
                onChange={(event: any) => set_startDate(event)} // eslint-disable-line
                maxDate={endDate}
            />
            <div>and</div>
            <DatePicker
                id='endDate'
                className='date-filter-date-picker'
                selected={endDate}
                onChange={(event: any) => set_endDate(event)} // eslint-disable-line
            />
        </div>
    );
};
